import { FLEETCOR } from "../constants/affiliations";
import { TOASTIFY_STATUS } from "../constants/application";
import { GENERIC_ERROR_MESSAGE } from "../constants/common";
import {
  AUTHENTICATION_TOKEN,
  BEARER,
  BROWSER_HEADERS,
  USER_DATA,
} from "../constants/storage";
import {
  getSessionStorage,
  setCookie,
  setSessionStorage,
} from "../helpers/browserStorage";
import { notifyToaster } from "../helpers/common";
import { setCommonLocation } from "../redux/slices/CommonLocation";
import { setPersonalInfo } from "../redux/slices/PersonalAccountInformationSlice";
import { store } from "../redux/Store";
import { postJSON } from "../utils/fetch";
import {setFirebaseAnalyticsUserId} from "../utils/googleAnalytics";
import {identifyEvent} from "../utils/segmentAnalytics";
import {COUNTRY_CODE} from "../constants/form";

const API_ENDPOINT = `${process.env.REACT_APP_API_HOST}/api/v6/sessions`;
const FLEET_DEFAULT = "fleet_default";

export const createUserSession = async ({ apiPayload }) => {
  try {
    const response = await postJSON(API_ENDPOINT, {
      ...apiPayload,
      is_split_flag: false,
      otp: null,
      query: FLEET_DEFAULT,
      subdomain: FLEETCOR,
    });

    if (response.error) {
      notifyToaster(response.error || GENERIC_ERROR_MESSAGE, {
        type: TOASTIFY_STATUS.error,
      });
      throw new Error(response.error);
    }

    const jwtToken = response.headers.get(BROWSER_HEADERS.XAuthJwt);
    setSessionStorage(USER_DATA, JSON.stringify(response.result));
    setCookie(AUTHENTICATION_TOKEN, `${BEARER} ${jwtToken}`);
    store.dispatch(setPersonalInfo({ personalInfo: response.result }));
    setFirebaseAnalyticsUserId(response.result.id);
    store.dispatch(
      setCommonLocation({ commonLocation: response?.result?.address ?? {} })
    );
    const currentUser = response.result;
    identifyEvent({
      traits: {
        firstName: currentUser.firstName,
        lastName: currentUser.lastName,
        phone: COUNTRY_CODE.concat(currentUser.cellPhone),
        zip: currentUser.zip,
        email: currentUser.email
      },
      userId: currentUser.id
    })

    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

/**
 * Checks if the user is logged in based on the presence of 'userData' in sessionStorage.
 *
 * This function checks if the 'userData' key exists in sessionStorage.
 * If 'userData' exists and has a valid value, the user is considered logged in.
 *
 * @returns {boolean} - True if the user is logged in, otherwise false.
 */
export const isUserSignIn = () => {
  const userData = getSessionStorage(USER_DATA);
  return !!userData;
};
